import React from 'react'

const Thanks = () => (
  <div className="form-container">
    <h1>Thank you!</h1>
    <h2>We'll be in touch shortly.</h2>
    <p>
      In the meantime, have you read our <a href="/blog">blog</a>?  You may also want 
      to check out the <a href="/university">Quick Sprout University</a>.
    </p>

  </div>
)

export default Thanks


// WEBPACK FOOTER //
// ./src/components/homepage/thanks.js